const FAQ_ITEMS = [
  {
    id: 1,
    q: '向日葵视频是什么？需要注册吗？',
    a: '向日葵视频是一个水果植物类视频平台的聚合导航入口，整合了香蕉视频、西瓜视频免费、蜜桃视频、樱花视频等优质视频站点。本站完全免费，无需注册即可浏览和使用所有导航功能。',
  },
  {
    id: 2,
    q: '这些水果视频在线平台安全吗？',
    a: '向日葵视频收录的所有平台均经过编辑团队人工评测和安全检测，确保无毒、无恶意弹窗、无诱导下载。我们定期巡查各平台状态，及时下架存在安全隐患的站点，保障用户浏览安全。',
  },
  {
    id: 3,
    q: '为什么叫向日葵视频？和水果有什么关系？',
    a: '向日葵是一种向阳而生的植物，象征着积极与活力。国内许多视频平台以水果命名（如香蕉视频、西瓜视频、蜜桃视频等），形成了一种独特的"水果视频"文化。向日葵视频作为聚合导航站，以向日葵为品牌符号，寓意汇聚阳光能量、连接优质内容。',
  },
  {
    id: 4,
    q: '观看视频需要付费吗？高清在线观看真的不缓冲吗？',
    a: '本站收录的平台中，香蕉视频、西瓜视频免费专区等提供大量免费内容。部分平台可能有会员专享内容，但免费内容占比很高。关于流畅度，我们优先收录支持多线路和高清播放的平台，实际体验取决于用户网络环境。',
  },
  {
    id: 5,
    q: '可以在手机上使用向日葵视频吗？',
    a: '当然可以！向日葵视频采用响应式设计，完美适配手机、平板和电脑端浏览器。在手机上访问体验同样流畅，所有水果视频在线平台的链接都可以直接在移动端浏览器中打开观看。',
  },
  {
    id: 6,
    q: '如何推荐新的植物视频平台给我们？',
    a: '欢迎通过页面底部的"联系投稿"入口向我们推荐未被收录的水果视频在线平台。请提供平台名称、网址和简要说明，编辑团队会在 3 个工作日内完成评测并反馈结果。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-2">
            常见问答
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            关于向日葵视频与水果视频在线平台的常见问题解答
          </p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3 md:space-y-4">
          {FAQ_ITEMS.map((item) => (
            <details
              key={item.id}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between px-5 md:px-6 py-4 md:py-5 list-none">
                <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 pr-4">
                  {item.q}
                </h3>
                <div className="w-7 h-7 rounded-full bg-background-100 flex items-center justify-center shrink-0 group-open:bg-primary-500 group-open:text-background-50 transition-all duration-200">
                  <i className="ri-arrow-down-s-line text-sm group-open:rotate-180 transition-transform duration-200"></i>
                </div>
              </summary>
              <div className="px-5 md:px-6 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}